import { render, staticRenderFns } from "./baseTable.vue?vue&type=template&id=5b29fb6a&scoped=true&"
import script from "./baseTable.vue?vue&type=script&lang=ts&"
export * from "./baseTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b29fb6a",
  null
  
)

export default component.exports